module.exports = __webpack_public_path__ + "static/media/Pochette_specimen.48d89e19.jpg";